import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { EngagementSurveyDetailTabsDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { SideContent } from 'modules/engagement_surveys/pages/SurveyOverviewPage/SideContent'
import { FormPreviewInline } from 'modules/forms'
import FormEditorExternal from 'modules/forms/components/editor/externalEditor/FormEditorExternal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function SurveyEditQuestionnairePage() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { data, loading, error } = useQuery(EngagementSurveyDetailTabsDocument, {
    variables: { surveyId: String(surveyId) },
    nextFetchPolicy: 'cache-first',
  })

  const survey = data?.surveys.survey

  const handleActionClick = (action: string) => {
    if (action === 'back') {
      navigate(navigation.engagement.smart_surveys.survey.fullPath({ surveyId: surveyId }))
    }
  }

  if (!survey) {
    return null
  }

  if (survey.form.status === 'draft') {
    return (
      <FormEditorExternal
        formId={survey.form.id}
        resourceType="Surveys::Survey"
        navigateBack={navigation.engagement.smart_surveys.survey.fullPath({ surveyId: surveyId })}
      />
    )
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      <Box border={{ top: { style: 'solid', width: 's1', color: 'grey200' } }}>
        <FormPreviewInline
          formId={survey.form.id}
          resourceType="Surveys::Survey"
          resourceId={surveyId}
          sideContent={<SideContent survey={survey} />}
        />
      </Box>
    </ResponsivePage.Body>
  )
}
